import store, { actions } from './store';

export { actions };
export default store;
